import { render, staticRenderFns } from "./EpoProductBanner.vue?vue&type=template&id=bf47f5d4&scoped=true&"
import script from "./EpoProductBanner.vue?vue&type=script&lang=js&"
export * from "./EpoProductBanner.vue?vue&type=script&lang=js&"
import style0 from "./EpoProductBanner.vue?vue&type=style&index=0&id=bf47f5d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf47f5d4",
  null
  
)

export default component.exports